// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5301":"dcc82c28","9754":"1ef1e4d3"}[chunkId] + ".chunk.css";
};